import { render, staticRenderFns } from "./AdminModels.vue?vue&type=template&id=ce06206e&scoped=true"
import script from "./AdminModels.vue?vue&type=script&lang=js"
export * from "./AdminModels.vue?vue&type=script&lang=js"
import style0 from "./AdminModels.vue?vue&type=style&index=0&id=ce06206e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce06206e",
  null
  
)

export default component.exports